import React, { useMemo } from "react";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { Project } from "fond/types";
import { AccordionStepper, AccordionStepperPane } from "fond/widgets";

import ServiceAreaPanel from "./ServiceAreaPanel";

interface ArtefactsPanelProps {
  project: Project;
  versionId: string;
  readOnly: boolean;
}

const ArtefactsPanel: React.FC<ArtefactsPanelProps> = ({ project, versionId, readOnly }: ArtefactsPanelProps) => {
  const { workflowState } = useCustomWorkflow({ versionId, key: "planner_extended_service_area" });

  const accordionPanes: AccordionStepperPane[] = useMemo(
    () => [
      {
        header: "Service Area",
        id: "service-area",
        content: <ServiceAreaPanel project={project} versionId={versionId} readOnly={readOnly} />,
        isComplete: workflowState === "COMPLETE",
      },
    ],
    [project, readOnly, versionId, workflowState]
  );

  return <AccordionStepper id={`${project.ID}-artefacts`} panes={accordionPanes} autoMove={[""]} variant="outlined" />;
};

export default ArtefactsPanel;
